import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MessageCircle, UserPlus, Award } from "lucide-react";

interface DuoRunSummaryProps {
  totalDistance: number;
  avgSync: number;
  syncPeaks: Array<{ km: number; sync: number }>;
  badgesEarned: string[];
  onClose: () => void;
}

export const DuoRunSummary = ({
  totalDistance,
  avgSync,
  syncPeaks,
  badgesEarned,
  onClose,
}: DuoRunSummaryProps) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4 animate-fade-in">
      <Card className="w-full max-w-md p-6 bg-card">
        <div className="text-center mb-6">
          <h2 className="text-xl font-bold mb-2">
            🏃‍♂️💨🏃‍♀️ Duo Run Concluído!
          </h2>
          <p className="text-muted-foreground">
            Parabéns pela corrida em dupla
          </p>
        </div>

        <div className="space-y-4 mb-6">
          <div className="grid grid-cols-2 gap-4">
            <div className="text-center p-4 bg-primary/10 rounded-lg">
              <div className="text-3xl font-bold text-primary">
                {(totalDistance / 1000).toFixed(2)}
              </div>
              <div className="text-sm text-muted-foreground">km juntos</div>
            </div>
            <div className="text-center p-4 bg-secondary/10 rounded-lg">
              <div className="text-3xl font-bold text-secondary">
                {avgSync.toFixed(0)}%
              </div>
              <div className="text-sm text-muted-foreground">sincronia média</div>
            </div>
          </div>

          {syncPeaks && syncPeaks.length > 0 && (
            <div className="p-4 bg-muted/50 rounded-lg">
              <h3 className="text-sm font-semibold mb-2">🔥 Picos de Sincronia</h3>
              <div className="space-y-1">
                {syncPeaks.map((peak, idx) => (
                  <div key={idx} className="flex justify-between text-sm">
                    <span>Km {peak.km}</span>
                    <span className="font-semibold text-primary">{peak.sync}%</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {badgesEarned && badgesEarned.length > 0 && (
            <div className="p-4 bg-primary/10 border border-primary/20 rounded-lg">
              <div className="flex items-center gap-3">
                <Award className="w-5 h-5 text-primary" />
                <div className="flex-1">
                  <h4 className="font-semibold mb-1">Conquistas Desbloqueadas</h4>
                  <div className="flex gap-2 flex-wrap">
                    {badgesEarned.map((badge, idx) => (
                      <Badge key={idx} variant="secondary" className="bg-primary/20">
                        {badge}
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="space-y-2">
          <Button className="w-full" size="lg">
            <MessageCircle className="w-4 h-4 mr-2" />
            Enviar Mensagem
          </Button>
          <Button variant="outline" className="w-full">
            <UserPlus className="w-4 h-4 mr-2" />
            Adicionar Amigo
          </Button>
          <Button variant="ghost" className="w-full" onClick={onClose}>
            Fechar
          </Button>
        </div>
      </Card>
    </div>
  );
};
